import { render, staticRenderFns } from "./WorkbenchConfig.vue?vue&type=template&id=12d94cfd&scoped=true"
import script from "./WorkbenchConfig.vue?vue&type=script&lang=js"
export * from "./WorkbenchConfig.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchConfig.vue?vue&type=style&index=0&id=12d94cfd&prod&lang=scss&scoped=true"
import style1 from "./WorkbenchConfig.vue?vue&type=style&index=1&id=12d94cfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d94cfd",
  null
  
)

export default component.exports